import React from "react"
import "../index.css";
import TopBar from "../catalog/sections/TopBar.jsx";
import "react-perfect-scrollbar/dist/css/styles.css";
import { MuiThemeProvider } from "@material-ui/core/styles";
import Scrollbar from "react-perfect-scrollbar";
import { Theme } from "../theme";
import GlobalCss from "../styles/jss/GlobalCss";
// const ListLink = props => (
//   <li style={{ display: `inline-block`, marginRight: `1rem` }}>
//     <Link to={props.to}>{props.children}</Link>
//   </li>
// )
export default function Layout({ children }) {
  return (
    <MuiThemeProvider theme={Theme}>
    <GlobalCss>
      <Scrollbar
        className="h-full-screen scrollable-content"
        option={{ suppressScrollX: true }}
      >
                  <TopBar />
{children}
      </Scrollbar>
    </GlobalCss>
    </MuiThemeProvider> 
    
    

  )
}